import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import useSWR from 'swr';
import { localAxios } from '../../api';

const AcknowledgeForm = (props) => {

    const { data, isLoading } = useSWR('/api/me', localAxios);

    const [firstName, setFirstName] = useState(() => data?.data?.first_name   ?? '');
    const [lastName,  setLastName]  = useState(() => data?.data?.last_name    ?? '');
    const [email,     setEmail]     = useState(() => data?.data?.email        ?? '');
    const [phone,     setPhone]     = useState(() => data?.data?.phone        ?? '');
    const [org,       setOrg]       = useState(() => data?.data?.organization ?? '');

    useEffect(() => {
        if (data?.data) {
            setFirstName(data.data.first_name   ?? '');
            setLastName (data.data.last_name    ?? '');
            setEmail    (data.data.email        ?? '');
            setPhone    (data.data.phone        ?? '');
            setOrg      (data.data.organization ?? '');
        }
    }, [data]);

    if (isLoading || !data?.data) return null;

    return (
        <div className="form-container">
            <Table align="center" striped bordered hover cellPadding={5}>
                <tbody>
                    <tr>
                        <td align="right">
                            <label>First Name:</label>
                        </td>
                        <td>
                            <input
                                type="text"
                                name="first_name"
                                autoComplete="given-name"
                                value={firstName}
                                onChange={e => setFirstName(e.target.value)}
                                width="200px"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td align="right">
                            <label>Last Name:</label>
                        </td>
                        <td>
                            <input
                                type="text"
                                name="last_name"
                                autoComplete="family-name"
                                value={lastName}
                                onChange={e => setLastName(e.target.value)}
                                width="200px"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td align="right"><label>Email:</label></td>
                        <td>
                            <input
                                type="text"
                                name="email"
                                autoComplete="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                width="200px"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td align="right"><label>Phone:</label></td>
                        <td>
                            <input
                                type="text"
                                name="phone"
                                autoComplete="tel"
                                value={phone}
                                onChange={e => setPhone(e.target.value)}
                                width="200px"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td align="right"><label>Organization:</label></td>
                        <td>
                            <input
                                type="text"
                                name="org"
                                autoComplete="organization"
                                value={org}
                                onChange={e => setOrg(e.target.value)}
                                width="200px"
                            />
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
};

export default AcknowledgeForm;
